module.exports = __webpack_public_path__ + "media/unipod/icon-delivery-white-0fe2afa7.svg";